import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useRef } from "react";
import { poleDisplay } from "../Account";
import StatsPoleTechnologie from "./StatsPoleTechnologie";
import StatsPoleTutorials from "./StatsPoleTutorials";

interface Props {
  pole: poleDisplay;
  genre: string;
}

const StatModal: React.FC<Props> = ({ pole, genre }) => {
  const modal = useRef<HTMLIonModalElement>(null);

  return (
    <>
      <IonButton
        id={"open-modal" + localStorage.getItem("techno") + pole.number + genre}
        shape="round"
        color="secondary"
        disabled={pole.active === false}
        style={{ width: "100%" }}
      >
        {pole.name}
      </IonButton>
      <IonModal
        ref={modal}
        trigger={
          "open-modal" + localStorage.getItem("techno") + pole.number + genre
        }
      >
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => modal.current?.dismiss()}>
                Retour
              </IonButton>
            </IonButtons>
            <IonTitle>Résultats de {pole.name}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          {genre === "techno" ? (
            <StatsPoleTechnologie
              pole={pole.number}
              type={localStorage.getItem("techno") ?? "pat"}
            />
          ) : (
            <StatsPoleTutorials
              pole={pole.number}
              type={localStorage.getItem("techno") ?? "pat"}
            />
          )}
        </IonContent>
      </IonModal>
    </>
  );
};

export default StatModal;
